/**
 * Created by zhoufei on 2017/9/11.
 */
import zh_CN from './config/zh-CN';
import en_US from './config/en_US';
import tl_PH from './config/tl_PH';

function isNullOrEmpty(obj) {
    var result = (obj == null || obj == undefined || obj == "" || obj == "null" || typeof obj == "undefined");
    if (result && (obj != 0 || obj != "0")) {
        return result;
    } else {
        return false;
    }
};

function getParamSearchByName(name) {
    var values = decodeURIComponent((location.search.match(RegExp("[?|&|/]" + name + '=([^\&|?&]+)')) || [, null])[1]);
    if (isNullOrEmpty(values)) {
        values = decodeURIComponent((location.hash.match(RegExp("[?|&|/]" + name + '=([^\&|?&]+)')) || [, null])[1]);
    }
    //针对react会自动在链接后面加#/，导致无法正确获取最后一个参数的值
    if (values.indexOf('#') > -1) {
        values = values.split('#')[0];
    }
    return isNullOrEmpty(values) || values == "null" ? "" : values;
}
export function LanguageFun() {
    let type = getParamSearchByName('lan') || "en_US";
    switch (type) {
        case 'zh_CN':
            return zh_CN;
            break;
        case 'en_US':
            return en_US;
            break;
        case 'tl_PH':
            return tl_PH;
            break;
        default:
            return en_US
            break;
    }
}
const Language = LanguageFun();
Language.type = getParamSearchByName('lan') || "en_US";
export default Language;


// WEBPACK FOOTER //
// ./src/language/index.js